export const EReportFlightDateType = {
   0: "UNKNOWN",
   1: "SALE",
   2: "FLIGHT",
   "-1": "ALL",
};

export const EReportHotelDateType = {
   0: "UNKNOWN",
   1: "SALES_AND_ACCOMMODATION",
   2: "SALES",
   3: "CHECK_IN",
   4: "CHECK_OUT",
   "-1": "ALL",
};

export const EReportTransferDateType = {
   0: "UNKNOWN",
   1: "SALE",
   2: "TRANSFER",
   "-1": "ALL",
};

export const EReportRentACarDateType = {
   0: "UNKNOWN",
   1: "SALE",
   2: "PICKUP",
   "-1": "ALL",
};

export const EReportRentACarReportType = {
   0: "UNKNOWN",
   1: "VEHICLE",
   2: "ANCILLARY",
   "-1": "ALL",
};

export const EReportSalesSumReportType = {
   0: "UNKNOWN",
   1: "SALE_GSA",
   2: "PROVIDER_GSA",
   "-1": "ALL",
};

export const EReportSalesType = {
   0: "UNKNOWN",
   1: "SALE",
   2: "REISSUE",
   "-1": "ALL",
};

export const EReportHotelSearchType = {
   0: "UNKNOWN",
   1: "AGENCY",
   2: "HOTEL",
   3: "LOCATION",
   "-1": "ALL",
};

export const EReportCmnGsaInvoiceProductType = {
   0: "UNKNOWN",
   1: "FLIGHT",
   2: "FLIGHT_ANCILLARY",
   3: "HOTEL",
   4: "HOTEL_ANCILLARY",
   5: "TRANSFER",
   6: "TRANSFER_ANCILLARY",
   7: "RENTACAR",
   8: "RENTACAR_ANCILLARY",
   "-1": "ALL",
};
